import React from 'react';

function ProductTitle({children}) {
  return (
    <div className="container-fluid main-container">
      <div className="row">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <div className="text-center mb40">
            <h1>
              {children}
            </h1>
            <p className="h4 demi-bold blue sub-heading mt20">
              CHOOSE A PACKAGE BELOW
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductTitle;



// WEBPACK FOOTER //
// ./src/components/ProductTitle/index.js